<template>
    <div class="buy-number">
        <dl class="item-line">
            <dt class="detail-field-label">数量</dt>
            <dd>
                <el-input-number
                    @change="hangenumbers($event)"
                    :value="internalValue" :step="1" size="mini" step-strictly 
                    @blur="blurInput"
                    ></el-input-number>
                <span class="inventory">库存：{{ goodsSkuDetail.stock_name || goodsSkuDetail.stock || goodsSkuDetail.goods_stock || '' }}</span>
            </dd>
        </dl>
        <template v-if="goodsMessageObj!=null">
            <div style="padding-left: 16px;">
                <goodsMessage :goods="goodsMessageObj"></goodsMessage>
            </div>
        </template>
    </div>
</template>

<script>
    import goodsMessage from '@/components/goods-message/goods-message.vue';
    export default {
        components: {
            goodsMessage
        },
        props: {
            value: {
                type: Number,
                default: 1
            },
            goodsSkuDetail: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                internalValue: this.value,
                goodsMessageObj:null
            };
        },
        watch: {
            value(newVal) {
                this.internalValue = newVal;
                if(this.goodsMessageObj!=null){
                    this.$set(this.goodsMessageObj,'num',this.internalValue);
                }
            },
            goodsSkuDetail(newVal){
                if(Object.keys(newVal).length > 2){
                    this.goodsMessageObj = newVal;
                    this.$set(this.goodsMessageObj,'num',this.internalValue);
                }
            }
        },
        methods: {
            hangenumbers(e) {
                if(e !=undefined){
                    this.internalValue = e
                }else{
                    this.internalValue  = 1
                }
                this.$emit('input', parseInt(this.internalValue));
            },
            keyInput() {
                this.internalValue = this.internalValue.replace(/\D/g, '');
                this.$emit('input', parseInt(this.internalValue));
            },
            changeNum(tag) {
                if (this.goodsSkuDetail.stock == 0) return;

                var stock = this.goodsSkuDetail.stock;
                var min = 1;

                if (tag === "+") {
                    if (this.internalValue < stock) {
                        if (this.goodsSkuDetail.min_buy > 1) {
                            var minbuysl = this.goodsSkuDetail.min_buy;
                            var Startingpurchase = this.internalValue + minbuysl;
                            this.internalValue = Startingpurchase;
                        } else {
                            this.internalValue++;
                        }
                    } else {
                        return;
                    }
                } else if (tag === "-") {
                    if (this.internalValue > min) {
                        if (this.goodsSkuDetail.min_buy > 1) {
                            var minbuysl = this.goodsSkuDetail.min_buy;
                            var Startingpurchase = this.internalValue - minbuysl;
                            this.internalValue = Startingpurchase;
                        } else {
                            this.internalValue -= 1;
                        }
                    } else {
                        return;
                    }
                }
                this.$emit('input', this.internalValue);
            },
            blurInput(){
                let time = Date.now();
                let stock = (this.goodsSkuDetail.stock || this.goodsSkuDetail.goods_stock || 0);
                let min = (this.goodsSkuDetail.min_buy?this.goodsSkuDetail.min_buy:1);
                if(this.internalValue > stock){
                    this.internalValue = stock;
                    sessionStorage.setItem('joinCartStatus',time);
                    this.$emit('input', this.internalValue);
                }
                if(this.internalValue < min){
                    this.internalValue = min;
                    this.$emit('input', this.internalValue);
                }
            }
        }
    };
</script>

<style scoped>
</style>








